import * as React from 'react';

var IsRestoringContext=React.createContext(false);var useIsRestoring=()=>React.useContext(IsRestoringContext);IsRestoringContext.Provider;

export { useIsRestoring };
//# sourceMappingURL=isRestoring.js.map
